// extracted by mini-css-extract-plugin
export default {"navIllustration":"OgBwIlri"};